module.exports = __webpack_public_path__ + "static/media/implant.ffd20546.svg";